import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import {
  IconBrandWhatsapp,
  IconExternalLink,
  IconInfoCircle,
  IconX,
} from "@tabler/icons-react";

const ModalTransferPix = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
  balance?: any;
  refetch?: any;
}) => {
  return (
    <Dialog maxWidth="xs" fullWidth open={open} onClose={() => onClose()}>
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={22} fontWeight={700}>
              Resgate de saldo
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX />
            </IconButton>
          </Grid2>

          <Grid2 size={12}>
            <Stack
              alignItems="center"
              spacing={2}
              sx={{
                backgroundColor: "secondary.dark",
                borderRadius: 2,
                padding: 3,
                textAlign: "center",
              }}
            >
              <IconInfoCircle size={48} color="#7600ED" />
              <Typography fontSize={16} fontWeight={700}>
                O resgate é feito diretamente pelo Mercado Pago
              </Typography>
              <Typography fontSize={14} color="text.secondary" lineHeight={1.6}>
                Por segurança, os saques do seu saldo não são realizados pelo
                nosso sistema. Você precisa acessar sua conta no{" "}
                <strong>Mercado Pago</strong> e solicitar a transferência
                diretamente por lá.
              </Typography>
              <Typography fontSize={13} color="text.secondary" lineHeight={1.6}>
                Caso tenha dúvidas sobre como realizar o resgate ou precise de
                ajuda, entre em contato com nosso suporte.
              </Typography>
            </Stack>
          </Grid2>

          <Grid2 size={12}>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              endIcon={<IconExternalLink size={18} />}
              onClick={() =>
                window.open(
                  "https://www.mercadopago.com.br/banking/balance#from-section=menu",
                  "_blank",
                )
              }
            >
              Acessar Mercado Pago
            </Button>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              endIcon={<IconBrandWhatsapp size={18} />}
              onClick={() =>
                window.open(
                  "https://wa.me/551926260132?text=Preciso%20de%20suporte%20para%20resgatar%20meu%20saldo",
                  "_blank",
                )
              }
            >
              Falar com o suporte
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default ModalTransferPix;
